import React from "react";
import t from "../i18n";
import { createHashHistory } from "history";
import { btnStyles } from "../_styles/button";
import { css } from "emotion";
import classNames from "classnames";

export class HomeFooter extends React.Component {
    createTopup = () => {
        const history = createHashHistory();
        history.push("/topup");
    }
    createAutoTopup = () => {
        const history = createHashHistory();
        history.push("/auto-topup");
    }
    render() {
        return <div>
            {/* DO NOT DELETE following line. We need to add extra 70 pixel for footer */}
            <div style={{ height: 70 }} />
            <div className="footer">
                <div className="container-fluid small-gutter text-right pr-lg-7 pl-lg-7 pr-md-5 pl-md-5">
                    <a className={classNames(['button', css(btnStyles.default)])} onClick={this.createTopup}>
                        {t.menu("send_balance")}
                    </a>
                    <a className={classNames(['button', css(btnStyles.default)])} onClick={this.createAutoTopup}>
                        {t.autoTopup("new_profile_button_title")}
                    </a>
                </div>
            </div>
        </div>
    }
}